import { render, staticRenderFns } from "./RIMomentoINBI.vue?vue&type=template&id=7b06d7e8"
import script from "./RIMomentoINBI.vue?vue&type=script&lang=js"
export * from "./RIMomentoINBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports